import { render } from "./RoleManagement.vue?vue&type=template&id=06ebcade&scoped=true"
import script from "./RoleManagement.vue?vue&type=script&lang=js"
export * from "./RoleManagement.vue?vue&type=script&lang=js"

import "./RoleManagement.vue?vue&type=style&index=0&id=06ebcade&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-06ebcade"

export default script